<template>
  <div>
    <template v-for="q in questions">
      <section :key="`trigger-for-${q.questionKey}`">
        <div class="m-0 flex justify-between align-center">
          <h3 class="ml-5 mt-0 mb-5">
            {{ q.uniqueKey }}
          </h3>
          <small class="feedback-tag info-box" v-if="q.showFeedback">
            Participant Feedback Active
          </small>
        </div>
        <div class="mb-10">
          <span
            v-for="({ name, color }, idx) in Array.from(q.tags).map((tagkey) => tags[tagkey])"
            :key="idx"
            :style="`background: ${color} !important`"
            class="question-tag"
          >
            {{ name }}
          </span>
        </div>
        <trigger-container
          :dependencies="q.dependsOn"
          :display-type-key="q.FK_questionDisplayTypeKey"
          :timer="q.timer"
          class="mt-5"
        />
        <view-mode
          :key="`question-${q.questionKey}`"
          :show-edit="false"
          :question="q"
          :character="characters[q.FK_authorKey]"
        />
      </section>
    </template>
  </div>
</template>

<script>
  import TriggerContainer from '@authoringPlatform/pages/Edit/pages/Inbox/MailView/TriggerContainer';
  import ViewMode from '@authoringPlatform/pages/Edit/pages/Inbox/MailView/ViewMode';

  import { mapState } from 'vuex';
  export default {
    components: {
      ViewMode,
      TriggerContainer,
    },
    computed: {
      ...mapState('editMode/questions', ['questions']),
      ...mapState('editMode/characters', ['characters']),
      ...mapState('editMode/tags', ['tags']),
    },
  };
</script>

<style lang="scss" scoped>
  .info-box {
    height: fit-content;
  }
  // overriding default print styles from Bootstrap. Otherwise the page would appear as black and white
  .mt-25 {
    margin-top: 25px !important;
  }

  ::v-deep {
    .bg-primary {
      color: #fff !important;
      background-color: #337ab7 !important;
    }
    .bg-success {
      background-color: #dff0d8 !important;
    }

    .bg-info {
      background-color: #d9edf7 !important;
    }

    .bg-warning {
      background-color: #fcf8e3 !important;
    }

    .bg-danger {
      background-color: #f2dede !important;
    }
  }
</style>
